<template>
    <div class="call-log">
        <Form inline :label-width="70">
            <FormItem label="操作账号">
                <Input @on-enter="getData" @on-clear="getData" clearable style="width: 180px" placeholder="请输入操作账号" v-model="form.userName"></Input>
            </FormItem>
            <FormItem label="接口名称">
                <Input @on-enter="getData" @on-clear="getData" clearable style="width: 180px" placeholder="请输入接口名称" v-model="form.apiName"></Input>
            </FormItem>
            <FormItem label="操作结果">
                <Select v-model="form.requestResult" @on-change="getData" placeholder="全部" clearable style="width: 180px">
                    <Option value="成功">成功</Option>
                    <Option value="失败">失败</Option>
                </Select>
            </FormItem>
            <FormItem label="调用时间">
                <DatePicker :value="timeList" transfer @on-change="changeDate" type="daterange" class="w220px" placeholder="请选择时间"></DatePicker>
            </FormItem>
            <FormItem :label-width="0">
                <Button icon="ios-search" class="mr-24" type="primary" shape="circle" @click="getData">搜索</Button>
                <Button shape="circle" @click="reset">
                    <Icon style="transform: rotateY(180deg)" type="md-refresh" />
                    重置
                </Button>
            </FormItem>
        </Form>
        <Table :loading="loading" :data="dataList" :columns="columns">
            <template slot="statusCode" slot-scope="{ row }">
                 <div
                :class="
                    `circle_dot ${
                    row.requestResult === '成功' ? 'circle_success' : 'circle_off'
                    }`
                "
                ></div>
                <span>{{row.requestResult === '成功'? "成功": "失败"}}</span>
            </template>
            <template slot="action" slot-scope="{ row }">
                <span @click="seeDetail(row)" class="fontblue fontcursor">详情</span>
            </template>
        </Table>
        <div class="flexend mt-24 pb-24">
            <Page placement="top" :current="form.pageIndex" :page-size="form.pageSize" :page-size-opts="[10, 20, 50, 100]" @on-change="changPageIndex" @on-page-size-change="changePageSize" :total="total" show-total show-elevator show-sizer></Page>
        </div>
        <Detail v-if="showDetail" :propForm="detailForm" @close="showDetail = false"></Detail>
    </div>
</template>

<script>
    import { getCallList } from "@/api/log.js";
    import Detail from "./log-detail.vue";
    export default {
        components: { Detail },
        data() {
            return {
                loading: false,
                timeList: [],
                showDetail: false,
                detailForm: {},
                form: {
                    pageIndex: 1,
                    pageSize: 10
                },
                dataList: [],
                total: 0,
                columns: [
                    {
                        title: "操作账号",
                        key: "userRealname",
                        tooltip: true
                    },
                    {
                        title: "服务",
                        key: "service",
                        tooltip: true
                    },
                    {
                        title: "调用时间",
                        key: "createTime",
                        tooltip: true
                    },
                    {
                        title: "接口名称",
                        key: "apiName",
                        tooltip: true
                    },
                    {
                        title: "请求方法",
                        key: "requestUri",
                        tooltip: true
                    },
                    {
                        title: "请求参数",
                        key: "requestParams",
                        tooltip: true
                    },
                    {
                        title: "请求类型",
                        key: "requestMethod",
                        width: "95"
                    },
                    {
                        title: "耗时",
                        key: "callDuration",
                        maxWidth: 100
                    },
                    {
                        title: "操作结果",
                        slot: "statusCode",
                        width: "95"
                    },
                    {
                        title: "操作",
                        slot: "action",
                        width: "65"
                    }
                ]
            }
        },
        created() {
            this.getData();
        },
        methods: {
            reset() {
                this.form = {
                    pageIndex: 1,
                    pageSize: 10
                };
                this.timeList = [];
                this.getData();
            },
            seeDetail(item) {
                this.detailForm = item;
                this.showDetail = true;
            },
            getData(resetPageIndex = true) {
                resetPageIndex && (this.form.pageIndex = 1);
                this.loading = true;
                getCallList(this.form).then(res => {
                    this.loading = false;
                    let json = res.data;
                    json.data.forEach(item => {
                        item.callDuration = item.callDuration + "ms";
                    })
                    this.dataList = json.data;
                    this.total = json.page.totalCount;
                }).catch(() => {
                    this.loading = false;
                })
            },
            changeDate(date) {
                if(date[0]) {
                    this.form.startTime = this.$moment(date[0]).format("YYYY-MM-DD 00:00:00");
                    this.form.endTime = this.$moment(date[1]).format("YYYY-MM-DD 23:59:59");
                } else {
                    this.form.startTime = "";
                    this.form.endTime = "";
                }
                this.getData();
            },
            changPageIndex(pageIndex) {
                this.form.pageIndex = pageIndex;
                this.getData(false);
            },
            changePageSize(pageSize) {
                this.form.pageSize = pageSize;
                this.getData();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .call-log {
        padding: 24px 32px 0;
        overflow: auto;
        height: 100%;
        & ::v-deep .ivu-form {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            .ivu-form-item{
                margin-right: 0px;
                margin-left: 24px;
            }
        }
    }
</style>
